import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document.querySelectorAll(".wp-block-weather-observation-map").forEach((el) => {
	const root = el.querySelector(".weather-observation-map__app");
	if (root) {
		createRoot(root).render(<App />);
	}
});
